import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { leftArrow } from "../../common/Assets/imgs";
import Header from "../../Components/Header";
import { formatKey, URLS } from "../../Services/Constant";
import { get, patch, post, put } from "../../Services/ApiHandler";
import toast from "react-hot-toast";

const AddRoles = () => {
  const navigation = useNavigate();
  const [roleName, setRoleName] = useState("");
  const [roles, setRoles] = useState([]); // [{ id, label }]
  const [permissionsList, setPermissionsList] = useState([]);
  const [permissionMeta, setPermissionMeta] = useState({}); // key -> api item
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const location = useLocation();
  console.log("location", location);
  const { data, type } = location.state || {};

  // permissions state
  const [permissions, setPermissions] = useState({});

  // role-wise select all state
  const [roleAllSelected, setRoleAllSelected] = useState({});

  const permissionOrder = useMemo(
    () => ["List", "Add", "Edit", "View", "Status", "Delete"],
    [],
  );
  const gridTemplateColumns = useMemo(() => {
    const cols = Math.max(roles.length, 1);
    return `repeat(${cols}, minmax(160px, 1fr))`;
  }, [roles.length]);
  const cardMinWidth = useMemo(() => {
    const cols = Math.max(roles.length, 1);
    return Math.max(880, cols * 180);
  }, [roles.length]);

  // single toggle
  const handleToggle = (roleId, perm) => {
    const key = `${roleId}_${perm}`;
    setPermissions((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      setRoleAllSelected((prevRoleAll) => ({
        ...prevRoleAll,
        [roleId]:
          permissionsList.length > 0 &&
          permissionsList.every((p) => next[`${roleId}_${p}`]),
      }));
      return next;
    });
  };

  // toggle all for a role column
  const handleRoleSelectAll = (roleId) => {
    const newValue = !roleAllSelected[roleId];

    const updatedPermissions = { ...permissions };
    const updatedRoleAll = { ...roleAllSelected };

    permissionsList.forEach((perm) => {
      updatedPermissions[`${roleId}_${perm}`] = newValue;
    });

    updatedRoleAll[roleId] = newValue;

    setPermissions(updatedPermissions);
    setRoleAllSelected(updatedRoleAll);
  };

  // global select all
  const handleSelectAll = () => {
    const updatedPermissions = {};
    const updatedRoleAll = {};

    Object.keys(permissions).forEach((k) => {
      updatedPermissions[k] = true;
    });

    roles.forEach((role) => {
      updatedRoleAll[role.id] = true;
    });

    setPermissions(updatedPermissions);
    setRoleAllSelected(updatedRoleAll);
  };

  const handleSubmit = async () => {
    const permissionIds = Object.entries(permissions)
      .filter(([_, status]) => Boolean(status))
      .map(([key]) => permissionMeta[key]?.id)
      .filter((id) => id != null);

    const payload = {
      name: roleName,
      code: roleName?.toUpperCase(),
      // status: true,
      permission_ids: permissionIds,
    };

    console.log("Role:", roleName);
    console.log("permission_ids:", permissionIds);

    try {
        setIsLoading(true);
      let res;
      if (type === "view") {
        res = await patch(`${URLS.ROLES_ADD_GET}${data?.id}/`, payload);
        console.log("submit res", res);
      } else {
        res = await post(`${URLS.ROLES_LIST}`, payload);
      }
      if (res?.status === 'success') {
        toast(res?.message);
        setIsLoading(false);
        navigation("/roles");
      }
    } catch (err) {
      console.log("submit err", err);
      setIsLoading(false);
    }
    finally {
        setIsLoading(false);
    }
  };

  useEffect(() => {
    if (type === "view" && data) {
      setRoleName(data?.name || "");
    }
  }, [data, type]);

  const getList = async () => {
    try {
      let res;
      if (type === "view") {
        res = await get(`${URLS.ROLES_ADD_GET}${data.id}/`);
      } else {
        res = await get(`${URLS.ROLES_ADD_LIST}`);
      }
      console.log("res", res);
      if (type === "view") {
        res = res?.data?.permissions;
      }
      if (Array.isArray(res)) {
        const moduleLabelById = new Map();
        const permNameSet = new Set();
        const permMetaMap = {};

        res.forEach((item) => {
          const moduleId = item?.module ?? item?.module_id ?? item?.moduleId;
          if (moduleId == null) return;
          if (!moduleLabelById.has(moduleId)) {
            const code = String(item?.code || "");
            const moduleRaw = code.split("-").slice(2).join("-");
            const label = moduleRaw
              ? formatKey(moduleRaw)
              : `Module ${moduleId}`;
            moduleLabelById.set(moduleId, label);
          }
          if (item?.name) permNameSet.add(item.name);
        });

        const roleList = Array.from(moduleLabelById.entries()).map(
          ([id, label]) => ({ id, label }),
        );

        const permNames = Array.from(permNameSet);
        const orderedPerms = [
          ...permissionOrder.filter((p) => permNameSet.has(p)),
          ...permNames.filter((p) => !permissionOrder.includes(p)),
        ];

        const initialPermissions = {};
        roleList.forEach((role) => {
          orderedPerms.forEach((perm) => {
            initialPermissions[`${role.id}_${perm}`] = false;
          });
        });

        res.forEach((item) => {
          const moduleId = item?.module ?? item?.module_id ?? item?.moduleId;
          const permName = item?.name;
          if (moduleId == null || !permName) return;
          const key = `${moduleId}_${permName}`;
          if (key in initialPermissions) {
            initialPermissions[key] = Boolean(item?.status);
            permMetaMap[key] = item;
          }
        });

        const roleAll = {};
        roleList.forEach((role) => {
          roleAll[role.id] =
            orderedPerms.length > 0 &&
            orderedPerms.every(
              (perm) => initialPermissions[`${role.id}_${perm}`],
            );
        });

        setRoles(roleList);
        setPermissionsList(orderedPerms);
        setPermissions(initialPermissions);
        setRoleAllSelected(roleAll);
        setPermissionMeta(permMetaMap);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div>
      <Header />
      <div className="add-admin-container">
        {/* HEADER */}
        <div className="admin-header">
          <div onClick={() => navigation(-1)} className="admin-header">
            <img src={leftArrow} className="back-icon-arrow" alt="" />
            <h2>Admin</h2>
          </div>

          <button
            className="select-btn"
            onClick={handleSelectAll}
            disabled={type === "view" && !isEdit}
          >
            Select All
          </button>
        </div>

        {/* ROLE INPUT */}
        <div className="form-group">
          <label className="adminsubhead">Role Name</label>
          <input
            type="text"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            readOnly={type === "view" && !isEdit}
          />
        </div>

        {/* PERMISSIONS */}
        <div className="permission-overlay">
          <div
            className="permissions-card"
            style={{ minWidth: `${cardMinWidth}px` }}
          >
            <h3>Permissions</h3>

            {/* HEADER ROLE TOGGLES */}
            <div
              className="permissions-row header-roles"
              style={{ gridTemplateColumns }}
            >
              {roles.map((role) => (
                <div key={role.id} className="cell">
                  <span style={{ width: 110 }}>{role.label}</span>

                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={roleAllSelected[role.id]}
                      onChange={() => handleRoleSelectAll(role.id)}
                      disabled={type === "view" && !isEdit}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              ))}
            </div>

            {/* PERMISSION ROWS */}
            {permissionsList.map((perm, i) => (
              <div
                key={i}
                className="permissions-row"
                style={{ gridTemplateColumns }}
              >
                {roles.map((role) => {
                  const key = `${role.id}_${perm}`;
                  return (
                    <div key={role.id} className="cell">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={permissions[key]}
                          onChange={() => handleToggle(role.id, perm)}
                          disabled={type === "view" && !isEdit}
                        />
                        <span className="slider"></span>
                      </label>
                      <span className="perm-text">{perm}</span>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* SUBMIT */}
        <div className="submit-container">
          {type === "view" && !isEdit && (
            <button
              onClick={() => setIsEdit(true)}
              className="edit-btn">Edit</button>
          )}
          {/* <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button> */}
          {(type === "add" || isEdit) && (
            <button onClick={handleSubmit} 
            className="save-btn"
            disabled={isLoading}
            >
              {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                ></span>
              </> 
              ): 
              (
                 'Submit'
                )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddRoles;
